"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svgDonutChart = _interopRequireDefault(require("./svgDonutChart"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function DonutChart(props) {
  function getTotal(data) {
    return data.map(function (entry) {
      return entry.value;
    }).reduce(function (accumulator, currentValue) {
      return accumulator + currentValue;
    });
  }

  function getPercentage() {
    var total = getTotal(props.data);

    if (total === 0) {
      return 0;
    }

    var accountableElements = props.data.filter(function (item) {
      return item.isPartOfMainPercentage;
    }).map(function (item) {
      return item.value;
    }).reduce(function (accu, value) {
      return accu + value;
    });
    return Number((accountableElements / total * 100).toFixed(0));
  }

  function getData() {
    var data = [];
    props.data.forEach(function (entry) {
      return data.push(_objectSpread({}, entry));
    });
    var total = getTotal(data);
    data = data.map(function (entry) {
      return _objectSpread(_objectSpread({}, entry), {}, {
        value: Number((entry.value / total * 100).toFixed(0))
      });
    });
    var missingPercentage = 100 - getTotal(data);

    if (missingPercentage !== 0) {
      // Find max entry and add the missing percentage
      data.reduce(function (p, v) {
        return p > v ? p : v;
      }).value += missingPercentage;
    }

    return data;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "donut-wrapper",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_svgDonutChart.default, {
      data: getData()
    }), props.mainPercentageLabel && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "donut-number-stats",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "number ".concat(props.numberColor || 'information-blue'),
        children: [getPercentage(), "%"]
      }), props.mainPercentageLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "label ".concat(props.textColor || 'paragraph-dark'),
        children: props.mainPercentageLabel
      })]
    })]
  });
}

DonutChart.propTypes = {
  data: _propTypes.default.array.isRequired,
  mainPercentageLabel: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  numberColor: _propTypes.default.string,
  textColor: _propTypes.default.string
};
DonutChart.defaultProps = {
  mainPercentageLabel: null,
  hidePercentage: false
};
var _default = DonutChart;
exports.default = _default;
//# sourceMappingURL=DonutChart.js.map